// Function to set the authentication token in localStorage
export const setAuthToken = (token) => {
      localStorage.setItem('id_token', token);
  };
  
  // Function to remove the authentication token from localStorage
  export const removeAuthToken = token => {
    
      localStorage.removeItem(token);
  };
  
  // Function to get the authentication token from localStorage
  export const getAuthToken = (token) => {
      return localStorage.getItem(token);
  };
  
  export const getFacilityId = () => {
    return localStorage.getItem('facilityId');
  }
  export const getcompanyId = () => {
    return localStorage.getItem('companyId');
  }
  export const getuserId = () => {
    return localStorage.getItem('UserId');
  }

  export const getCreatedBy = () => {
    return localStorage.getItem('UserId');
  }

  export const getModifiedBy = () => {
    return localStorage.getItem('UserId');
  }

  export const getcompanyname = () => {
    return localStorage.getItem('companyName');
  }

  export const getUserLoginStatus =async (key) => {
    await localStorage.getItem(key);
};

export const removeUserLoginStatus = async(key) => {
  localStorage.removeItem(key);
};

export const getTheme = () => {
  return localStorage.getItem('Theme');
}
export const getWidgets = () => {
  return localStorage.getItem('Widgets');
}

export const removeFCMToken = (fcmToken) => {
  console.log("fcmToken",fcmToken);
  
  localStorage.removeItem(fcmToken);
}